module.exports = __webpack_public_path__ + "img/tree-07-h-trunk.8b969580.png";